import React, {Component} from 'react';
import EditAccountView from "./EditAccountView";
import {Growl} from "primereact/growl";
import {MaintenanceAccountsService} from "../../../service/admin/maintenanceAccounts/MaintenanceAccountsService";

/**
 * Función que valida un conjunto de datos que son requeridos en la vista.
 * @param accountData Objeto que contiene los datos
 * @returns {{descrCuenta: boolean, boveda: boolean, cuenta: boolean, nombreCorto: boolean}}
 *          Map que indica cuales de ellos ya han sido llenados.
 */
function validate(accountData) {
    return {
        cuenta: accountData.cuenta === "",
        boveda: accountData.boveda === "",
        nombreCorto: accountData.nombreCorto === "",
        descrCuenta: accountData.descrCuenta === "",
    };
}

export default class EditAccountContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * Se toma el elemento a editar que viene de la pantalla anterior.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.maintenanceAccountsService = new MaintenanceAccountsService();
        this.getAccountData = this.getAccountData.bind(this);
        this.onChangeDropDown = this.onChangeDropDown.bind(this);

        this.state = {
            returnPath: this.props.location.state.returnPath,
            datosCuenta: this.getAccountData(),
            errorClass: 'p-error',
            efectivoCheck: this.props.location.state.datosCuenta.banderaCuentaEfvo !== '1',
            errors: {
                cuenta: '',
                boveda: '',
                nombreCorto: '',
                descrCuenta: '',
            },
            isLoading: true,
        };

        this.onChangeInputText = this.onChangeInputText.bind(this);
        this.onChangeSelectBox = this.onChangeSelectBox.bind(this);
        this.editAccount = this.editAccount.bind(this);
        this.validateErrors = this.validateErrors.bind(this);
        this.returnMaintenancePage = this.returnMaintenancePage.bind(this);
        this.loading = this.loading.bind(this);
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    /**
     * Función que hace una petición al servicio MaintenanceAccountsService
     * para consultar los datos de la cuenta que se va a editar en la pantalla.
     *
     */
    getAccountData() {
        let accountAux = this.props.location.state.datosCuenta;
        return (
            this.maintenanceAccountsService.getInfoAccount(accountAux['cuenta'])
                .then(result => {
                    this.setState({
                        datosCuenta: result,
                        isLoading: false,
                    });
                })
        )
    }

    /**
     * Función que maneja el cambio de valor en los campos de texto
     * y los coloca en el state dentro del objeto que se va a editar.
     * @param event Contiene el valor que fue modificado en la vista.
     */
    onChangeInputText(event) {
        const {name, value} = event.target;
        let datosCuenta = this.state.datosCuenta;
        datosCuenta[name] = value;
        this.setState({datosCuenta: datosCuenta,})
    }

    onChangeDropDown(event) {
        let {value} = event.target;
        value = value ? value : '';

        this.setState({cuentaValorGSS: value,})
    }

    /**
     * Función que maneja el cambio de valor que se realice en el select
     * box que se muestra en la vista y coloca el valor en el state
     * dentro del objeto a editar.
     * @param event Contiene el valor que fue modificado en la vista.
     */
    onChangeSelectBox(event) {
        let datosCuenta = this.state.datosCuenta;
        event.checked ?
            datosCuenta['banderaCuentaEfvo'] = '2' :
            datosCuenta['banderaCuentaEfvo'] = '1';
        this.setState({
            efectivoCheck: event.checked,
            datosCuenta: datosCuenta,
        });
    }

    /**
     * Función que valida el map que contiene si los campos están llenos
     * si hay alguno que no esté lleno, regresa false, si no true.
     * @param {Map} Errors Map que contiene valores true o false de acuerdo
     *              a si está lleno.
     * @returns {boolean} Regresa un tue si todos entrán llenos
     */
    validateErrors(errors) {
        let result = false;

        for (let elem in errors) {
            if (this.state.datosCuenta[elem] === '') {
                result = true;
                return true;
            }
        }
        return result;
    }

    /**
     * Función que regresa a la pantalla de
     * Mantenimiento de cuentas y bóvedas.
     */
    returnMaintenancePage(response) {
        this.setState({isLoading: false,});

        let message = '';

        if (response.message !== undefined) {
            message = {
                severity: 'success',
                summary: 'Éxito',
                detail: response.message,
            };
        }

        this.props.history.push({
            pathname: this.state.returnPath,
            message: message,
        });
    }

    /**
     * Función que consume a MaintenanceAccountsService para guardar los datos
     * del elemento a editar.
     * Se hace una validación que estén presentes los datos obligatorios.
     */
    editAccount() {
        this.setState({errors: validate(this.state.datosCuenta)});

        if (!this.validateErrors(this.state.errors)) {
            this.loading();
            this.maintenanceAccountsService.updateAccount(this.state.datosCuenta, this.state.cuentaValorGSS)
                .then(res => {
                    let messageObj = {};
                    if (res.message !== "") {
                        messageObj['severity'] = 'success';
                        messageObj['sumary'] = 'Éxito';
                        messageObj['detail'] = res.message;
                        this.returnMaintenancePage(messageObj)
                    } else if (res.error !== "") {
                        this.growl.show({severity: 'error', summary: 'Error.', detail: res.error});
                    }
                    this.loading(false);
                });
        } else {
            this.growl.show({severity: 'error', summary: 'Error.', detail: 'Llenar los campos requeridos'});
        }

    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {cuentaValorGSS, datosCuenta, errorClass, errors, efectivoCheck, isLoading} = this.state

        return (
            <EditAccountView datosCuenta={datosCuenta}
                             onChangeInputText={this.onChangeInputText}
                             onChangeSelectBox={this.onChangeSelectBox}
                             onChangeDropDown={this.onChangeDropDown}
                             messagesGrowl={messagesGrowl}
                             editAccount={this.editAccount}
                             errorClass={errorClass}
                             errors={errors}
                             efectivoCheck={efectivoCheck}
                             cuentaValorGSS={cuentaValorGSS}
                             isLoading={isLoading}
                             returnMaintenancePage={this.returnMaintenancePage}
            />
        );
    }
}
